<div class="p-4 overflow-auto h-[85vh]">

  <div class="flex justify-between -mt-4">
    <h2 class="text-xl font-semibold">Users</h2>
    <p-button icon="pi pi-plus" label="Add Users" (click)="openAddModal()" class="mb-3"></p-button>
  </div>


  <p-table [value]="users" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading" [paginator]="true"
    [responsive]="true" (onLazyLoad)="loadUsers($event)">
    <ng-template pTemplate="header">
      <tr>
        <th>Username</th>
        <th>Name</th>
        <th>Email</th>
        <th>Created Date</th>
        <th>Status</th>
        <th>Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
      <tr>
        <td>{{ user.username }}</td>
        <td>{{ user.fname }} {{ user.lname }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.createdAt | date }}</td>
        <td>{{ user.status }}</td>
        <td>
          <div (click)="setUserDataToEdit(user)">
            <p-menu [tabindex]="undefined" #menu [model]="userActionItem" [popup]="true" appendTo="body"></p-menu>
            <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button cursor-pointer"></i>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loading">
      <tr>
        <td colspan="6" class="text-center">
          <p-progressSpinner></p-progressSpinner>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="6" class="no-data-record-found">
          <p>No records found</p>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- MODAL -->
  <ng-container *ngIf="showModal">
    <p-dialog [(visible)]="showModal" [modal]="true" [style]="{ width: '75vw' }" [closable]="false">
      <app-create-user [departments]="departments" [campuses]="campuses" [roles]="roles" [orgId]="orgId"
        (closeModal)="showModal = false" (reload)="reloadUsers()" />
    </p-dialog>
  </ng-container>

  <ng-container *ngIf="showEditUser">
    <p-dialog [(visible)]="showEditUser" [modal]="true" [style]="{ width: '75vw' }" [closable]="false">
      <app-create-user
      [userDataToEdit]="userDataToEdit"
      [type]="'Update'"
      [departments]="departments" [campuses]="campuses" [roles]="roles" [orgId]="orgId"
        (closeModal)="showEditUser = false" (reload)="reloadUsers()" />
    </p-dialog>
  </ng-container>

  <ng-container *ngIf="showDeleteUser">
    <p-dialog [(visible)]="showDeleteUser" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
      <app-delete-user [orgId]="orgId" (reload)="reloadUsers()" [userDataToEdit]="userDataToEdit"
        (close)="showDeleteUser = false"></app-delete-user>
    </p-dialog>
  </ng-container>
</div>